import React from 'react';
import { ActivationData } from '../../../interfaces';
import { NotificationView } from '../notification-view';
import { useEntityLogo } from '@hevoio/hevo-ui-toolkit';
import { HdIcon } from '../../../../../components';
import styles from './ActivationView.module.scss';

export function ActivationView({ data }: NotificationView<ActivationData>) {
  const warehouseThumbnail = useEntityLogo(
    data.warehouseTypeLogoUrl,
    data.warehouseTypeDarkModeLogoUrl
  );
  const targetThumbnail = useEntityLogo(data.targetTypeLogoUrl, data.targetTypeDarkModeLogoUrl);

  return (
    <div className={styles.activationViewContainer}>
      <div className={styles.nodeInfo}>
        {data.warehouseTypeLogoUrl ? (
          <div className={styles.nodeImage}>
            <img src={warehouseThumbnail} alt='' />
          </div>
        ) : null}

        <div className={styles.nodeName}>{data.warehouseName}</div>
      </div>

      <HdIcon name='back' size={0} className={styles.connectionIndicator} />

      <div className={styles.nodeInfo}>
        {data.targetTypeLogoUrl ? (
          <div className={styles.nodeImage}>
            <img src={targetThumbnail} alt='' />
          </div>
        ) : null}

        <div className={styles.nodeName}>{data.targetName}</div>
      </div>
    </div>
  );
}
